import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"


const OPTIONS = [
    { label: 'Slave 1', value: '1' },
    { label: 'Slave 2', value: '2' },
    { label: 'Slave 3', value: '3' },
]

export default function SelectUserSlaves({ ...props }) {

    const myProps = {
        placeholder: 'Select user slaves', label: 'User slaves',
        firstSelect: true, isClearable: false, options: OPTIONS,
        icon: { icon: 'user' }, isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}